<template>
  <div>
    <slot />
  </div>
</template>

<script setup>
const route = useRoute();
import { useWindowScroll } from "@vueuse/core";
const { clear } = useBodyOF();
const { y } = useWindowScroll();
onMounted(() => {
  clear();
  if (!route.hash || route.hash == "#") return;
  const el = document.getElementById(route.hash.substring(1));
  if (!el) return;
  const br = document.body.getBoundingClientRect();
  const er = el.getBoundingClientRect();
  y.value = er.top - br.top;
});
</script>
